// @flow

import React from 'react';

import { Icon, IconClose, IconAddPeople, IconInviteMore, IconPeople } from '../../../base/icons';
import { connect } from '../../../base/redux';

import {
    getParticipantCountWithFake
} from '../../../base/participants';
import { getCurrentRoomId, getBreakoutRooms } from '../../../breakout-rooms/functions';

type Props = {

    /**
     * Function to be called when pressing the close button.
     */
    onCancel: Function,

    /**
     * An optional class name.
     */
    className: string,
};

/**
 * Custom header of the {@code PeopleDialog}.
 *
 * @returns {React$Element<any>}
 */
function Header({ onCancel, className, currentRoom, participantsCount }: Props) {
    return (
        <div
            className = { className || 'chat-dialog-header' }>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Icon
                    onClick = { onCancel }
                    src = { IconPeople } />
                <span>&nbsp;&nbsp;{ currentRoom?.name ? `${currentRoom?.name.indexOf('-') ? currentRoom?.name.split(/-(.*)/s)[1]: currentRoom?.name}` : 'People' } &nbsp;&nbsp;<small><b><i>( { participantsCount } )</i></b></small></span>
            </div>
            <Icon
                onClick = { onCancel }
                src = { IconClose } />
        </div>
    );
}

function _mapStateToProps(state): Object {
    const participantsCount = getParticipantCountWithFake(state);
    const currentRoomId = getCurrentRoomId(state);
    const { [currentRoomId]: currentRoom } = getBreakoutRooms(state);

    return {
        currentRoom,
        participantsCount
    };
}

export default connect(_mapStateToProps)(Header);